import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';

export interface StenaAffirmOrDismissDialogData {
  title: string;
  description: string;
  affirmButtonText: string;
  dismissButtonText: string;
  affirmButtonColor?: string;
}

@Component({
  selector: 'stena-affirm-or-dismiss-dialog',
  templateUrl: './stena-affirm-or-dismiss-dialog.component.html',
  styleUrls: ['./stena-affirm-or-dismiss-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
  ],
  standalone: true,
})
export class StenaAffirmOrDismissDialogComponent {
  private readonly dialogRef =
    inject<MatDialogRef<StenaAffirmOrDismissDialogComponent, boolean>>(
      MatDialogRef
    );
  data = inject<StenaAffirmOrDismissDialogData>(MAT_DIALOG_DATA);
}
